import { File, FileText, Image } from 'lucide-react';

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png']);
const DOCUMENT_EXTENSIONS = new Set(['doc', 'docx']);
// Extensions we recognise and therefore hide from the rendered file name
// (e.g. "report.pdf" -> "report"). Kept local to the design-system package so
// file-card does not couple to the app's upload policy
// (`@/lib/fileUploadLimits`); mirrors the context-document formats that
// were the original source of this list.
const KNOWN_FILE_EXTENSIONS = '.doc,.docx,.pdf,.png,.jpg,.jpeg';
const VALID_FILE_EXTENSIONS = new Set(
  KNOWN_FILE_EXTENSIONS.split(',').map((ext) => ext.toLowerCase())
);

/**
 * Checks if a filename has a valid/known file extension.
 * Only extensions from CONTEXT_DOCUMENTS_ACCEPT_FORMATS are considered valid.
 * e.g., "document.pdf" -> true (has valid extension, don't show it)
 * e.g., "file.name.abc" -> false (abc not in valid list, show full name)
 * e.g., "noextension" -> false (no extension)
 */
export const hasValidFileExtension = (fileName: string): boolean => {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return false;
  }
  const extension = fileName.slice(lastDotIndex).toLowerCase();
  return VALID_FILE_EXTENSIONS.has(extension);
};

export const getFileIcon = (fileType?: string) => {
  if (!fileType) return File;

  const normalizedType = fileType.toLowerCase().replace(/^\.+/, '');

  if (IMAGE_EXTENSIONS.has(normalizedType)) {
    return Image;
  }

  if (DOCUMENT_EXTENSIONS.has(normalizedType)) {
    return FileText;
  }

  return File;
};
